import * as React from 'react';
import { withTranslation } from '@i18n';
import { LocationIcon } from '@images/svg/index';
import { useBreakpoint } from '@hooks';
import { BulletList } from '@components/index';

import {
  StyledCardWrapper,
  StyledFlexWrapper,
  StyledImageWrapper,
  StyledRightWrapper,
  StyledHeadline,
  StyledLocationWrapper,
  StyledDescription
} from './styles';
import { StyledGridUnit, StyledGridWrapper } from '../../../../Profile/ProfilePackages/styles';

const CityTourCard = ({ t, data }) => {
  const { places } = data;
  const isMobile = useBreakpoint('mobile', 'desktop');

  return (
    <StyledCardWrapper>
      {!isMobile && (
        <StyledFlexWrapper>
          <StyledHeadline>{t('CityTour.Headline')}</StyledHeadline>
          <StyledLocationWrapper>
            <LocationIcon />
            {data.city}
          </StyledLocationWrapper>
        </StyledFlexWrapper>
      )}
      <StyledGridWrapper>
        <StyledGridUnit size={{ mobile: 1 / 1, desktop: 1 / 2 }}>
          <StyledImageWrapper>
            <img src={data.cover_image.url} alt={data.city} />
          </StyledImageWrapper>
        </StyledGridUnit>
        {isMobile && (
          <StyledFlexWrapper>
            <StyledHeadline>{t('CityTour.Headline')}</StyledHeadline>
            <StyledLocationWrapper>
              <LocationIcon />
              {data.city}
            </StyledLocationWrapper>
          </StyledFlexWrapper>
        )}
        <StyledGridUnit size={{ mobile: 1 / 1, desktop: 1 / 2 }}>
          <StyledRightWrapper>
            <StyledHeadline>{t('CityTour.HistoricalPlaces')}</StyledHeadline>
            <StyledDescription>
              <BulletList bullets={places} />
            </StyledDescription>
          </StyledRightWrapper>
        </StyledGridUnit>
      </StyledGridWrapper>
    </StyledCardWrapper>
  );
};

export default withTranslation('ProfilePackages')(CityTourCard);
